import { defaultReceiverState } from './state';

export const getDefaultAddressState = () => defaultReceiverState().address;
export const getDefaultPhoneState = () => defaultReceiverState().phone;
export const getDefaultReceiverState = () => defaultReceiverState();
export const serviceCollection = (state) => state.nfse.services.serviceCollection;
export const paymentModeCollection = (state) => state.nfse.payments.paymentModeCollection;
export const totalNfse = (state) => state.nfse.taxes.total;
export const nfse = (state) => state.nfse;
